import * as CryptoJS from 'crypto-js';

export class TraceIdHelper {

  /**
   * generate a trace id of device_info
   * @memberof TraceIdHelper
   * @return {string}
   */

  generateTraceID(deviceInfo: string) {
    const traceID = `${deviceInfo}_${ CryptoJS.lib.WordArray.random(50)}_${Date.now()}`;
    const hashedTrace = CryptoJS.SHA256(traceID);
    const preResult = CryptoJS.enc.Base64.stringify(CryptoJS.SHA256(hashedTrace))
    .replace(/\+/g, '-')
    .replace(/\//g, '_').split('');
    return `${preResult.slice(7).join('')}${preResult.slice(-7).join('')}`;
  }
}
